import React from 'react';
import Configurer from '../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import ModernBg1 from '../../components/ModernBg1';
import Responsive from '../../components/Responsive';
import { fetchWallpaper, imageAddress, translate } from '../../utils/useful';
import { siteConfig, siteTheme } from '../../variables/config';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import Header from '../../components/header/Header';
import CAHeader from '../../components/header/CAHeader';

export default class CAInfo extends React.Component {

    state = {
        formHeaders: [
            { key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { placeholder: '{{lang}}ca.image', placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } },
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}ca.name', placeholder: '{{lang}}ca.name', required: true } },
            { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}ca.description', placeholder: '{{lang}}ca.write the description', required: false } }

        ],


        // showToolbar: true,
    }



    nextStage = (cb) => {
        if (this.form) {
            let data = this.form.getForm()
            // console.log(data)
            if (data) {
                // window.scrollTo(0, 0)
                this.props.setData(data, () => {
                    // console.log('data202', data)
                    // return
                    this.setState({ isLoading: true, errors: {} })

                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // console.log('data',this.props.initData)
                    this.props.createApplet(() => {
                        this.setState({ isLoading: false })
                    })

                    // })
                })
            }
        }
    }


    formLiveChange = (data) => {

        if (data?.name && data?.name != '') {
            this.setState({ canContinue: true })
        } else {
            this.setState({ canContinue: false })
        }
    }
    componentDidMount() {
        this.props.showHeader(true, () => {
            if (this.props.setHeader) {
                // this.props.setHeader("dummy",1)
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    // 'title': `${this.props.user?.info?.fullname}`,
                    isPortal: true, doNotshowNotification: true,
                    showSettings: false,
                    create: true,
                    'title': "Create Applet | Applet Information",
                    topHeaderComponent: this.topHeaderComponent,
                    backAction: () => this.props.lastStage()
                })
            }
        })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static',
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    isLoading={this.state.isLoading}
                    title={translate("ca.Create Applet")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
                {/* <p></p> */}
            </div>

        )
    }




    render() {
        return (



            <div className=" w-100 h-100   position-relative overflow-hidden " style={{ position: 'relative', borderBottomRightRadius: '10px' }}>
                <div className='w-100 h-100 position-absolute overflow-hidden '>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>

                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>

                    </div>
                </div>
                {/* <ModernBg1 /> */}
                {/* <div style={{ position: 'relative', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />
                </div> */}

                <div className='d-flex w-100 h-100'>

                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '12', lg: "12", xl: "12" }}>
                        <div className='h-100 w-100 flexc flex-column scroll-no-scrollbar' style={{ padding: '0px 0%' }}>
                            <div className='w-100 ' style={{}}>


                                <div className='px-4 pb-2 flexcb w-100 pt-0' >

                                    {/* <div className='flexc  p'>
                                        <div className='flexcc' style={{ backgroundColor: '#78419230', height: 24, width: 24, borderRadius: 20 }}>
                                                    <p className=' text-bold' style={{ color: '#24113C' }}>2</p>
                                                </div>

                                        <button onClick={() => this.props.lastStage()} className='flexc'>
                                            <div className='bg-dark-blue-1 br-50 ws-25 hs-25 flexcc'>
                                                <img className={' invert ' + (this.props.language == "fa" ? "" : "rotate-180")} src="/assets/icons/useful/angle-right.svg" height={20} />
                                            </div>
                                        </button>
                                        <h2 className=" text-big mb-0 color-dark-blue-1 mx-3" >{translate('ca.Applet Information')}</h2>

                                        <h2 className="mt-0 text-normal mb-0 mx-2" style={{ color: '#24113C' }} >{translate('Create Applet | Info')}</h2>
                                    </div> */}
                                    {/* <div style={{ maxWidth: 450 }}>
                                            <p className="mt-1 text-smaller opacity-7" style={{ color: '#3C3811' }} >{translate("Hub type does not limit you in it's usage, it just helps us to recommend you better solutions")}</p>
                                        </div> */}



                                    <div className='flexc'>

                                        {/* <button onClick={() => this.props.lastStage()} className="text-small mx-2" >
                                                <img className='rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                            </button> */}

                                        {/* <div className='mx-1'>
                                                <button onClick={() => this.props.lastStage()} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>

                                                    <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                        <img className='invert rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button>
                                            </div> */}


                                        {/* <div>
                                                <button onClick={() => this.nextClicked()} className='px-1 py-1  flexcc' style={{ filter: !this.state.canContinue ? 'saturate(20%) ' : '', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Next Step")}</p>

                                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                        <img className='invert' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button>
                                            </div> */}
                                    </div>
                                </div>

                                {/* <div className='px-1'>
                                        <div className='w-100 ' style={{ backgroundColor: '#fff', height: 16, borderRadius: '16px 16px 0px 0px', transform: 'translateY(1px)', marginTop: -1 }}></div>
                                    </div> */}



                                <div className='px-1 flexcc' style={{}}>
                                    <div className='px-4 mt-2' style={{ borderRadius: '16px 16px 16px 16px', position: 'relative' }}>
                                        <div>
                                            <div className='d-flex flex-wrap mt-3' style={{ maxWidth: 500 }}>
                                                <div className='px-2 mb-3'>
                                                    <p className="mt-0 text-semibig mb-0 mx-2 text-semibold" style={{ color: '#212529' }} >{translate('Applet information')}</p>
                                                    <p className="mt-0 text-smaller mt-1 mb-0 mx-2 " style={{ color: '#212529' }} >{translate('You will see your applet with these data that you provide. You can change them later')}</p>

                                                </div>
                                                <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'white-input with-shadow'} liveChange={this.formLiveChange} />
                                            </div>




                                        </div>


                                    </div>
                                </div>




                            </div>






                        </div>
                    </Responsive>


                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", sm: '4', md: '4', lg: "6", xl: "6" }}>

                        <div className="text-center" style={{ minHeight: '100vh', position: 'relative', top: 0, padding: '100px 30px 20px 30px', backgroundPosition: 'center', backgroundSize: 'cover' }}>


                            <div className='flexc flex-column' style={{ position: 'sticky', top: 70 }}>
                                <img className=" mb-2" src={'/assets/icons/portals/Asset 2.svg'} width={'90px'} />
                                <p className="text-big text-bold">{translate("Create Hub").toUpperCase()}</p>
                                <p className=" text-smaller" style={{ maxWidth: '300px' }} >{translate("Description about new hub and the terms of use will be shown here")}</p>
                            </div>
                        </div>

                    </Responsive> */}

                </div>


            </div>


        )
    }
}